import { IScreen, PresentationScreenKey } from '~/client/graph'

export const defaultPresentationScreens = [
  PresentationScreenKey.Deliveries,
  PresentationScreenKey.Logistics,
  PresentationScreenKey.Forms,
].map(
  (key, idx) =>
    ({
      key,
      order: idx + 1,
      duration: 30,
      isShown: true,
    }) as IScreen,
)

export const trackerRelatedScreens = new Set([PresentationScreenKey.Gantt])

export const deliveryRelatedScreens = new Set([
  PresentationScreenKey.Deliveries,
])

export const logisticsRelatedScreens = new Set([
  PresentationScreenKey.Logistics,
])

export const formsRelatedScreens = new Set([PresentationScreenKey.Forms])
